export default "__VITE_ASSET__$rSumpJF__"